module.exports = __webpack_public_path__ + "img/jindocoin-taxi.40f5a489.jpg";